export const CONFIRM_POPOVER_MSGS = {
  IDTF_RECORDING_CONFIRM:
    'By confirming, you will be marking this recording as read.',
};



// WEBPACK FOOTER //
// ./src/views/constsnts/confirmMessages.js